import React, { useState, createContext } from 'react';

export const StateContext = createContext()

export const StateProvider = (props) => {

    const [isMicOn, setIsMicOn] = useState(false);
    const [note, setNote] = useState(null)
    const [savedNotes, setSavedNotes] = useState([])
    const [savedTitles, setSavedTitles] = useState([])

    const [newNote, setNewNote] = useState(false)
    const [title, setTitle] = useState('')
    const [showTitle, setShowTitle] = useState(false)

    const [clickedTitle, setClickedTitle] = useState('')

    return (
        <StateContext.Provider
            value={{
                isMicOnObj: [isMicOn, setIsMicOn],
                noteObj: [note, setNote],
                savedNotesObj: [savedNotes, setSavedNotes],
                newNoteObj: [newNote, setNewNote],
                titleObj: [title, setTitle],
                showTitleObj: [showTitle, setShowTitle],
                savedTitlesObj: [savedTitles, setSavedTitles],
                clickedTitleObj: [clickedTitle, setClickedTitle]
            }}
        >
            {props.children}
        </StateContext.Provider>
    )
}